module.exports = __webpack_public_path__ + "assets/4c4693f2d9780e8410000182adc7bcc4.png";